import { useFidc } from "@/lib/fidc-context";
import { Layers } from "lucide-react";

export function FidcSelector(): JSX.Element | null {
  const { fidcId, setFidcId, fidcs, loading } = useFidc();
  if (loading) return null;
  if (fidcs.length === 0) return null;
  return (
    <div className="flex items-center gap-2">
      <Layers className="h-4 w-4 text-muted-foreground" />
      <select
        value={fidcId ?? ""}
        onChange={(e) => setFidcId(e.target.value || null)}
        className="h-8 rounded-md border border-input bg-background px-2 text-xs min-w-[200px] max-w-[260px]"
        title="Filtra todas as visões pelo FIDC selecionado"
      >
        <option value="">Todos FIDCs ({fidcs.length})</option>
        {fidcs.map((f) => (
          <option key={f.id} value={f.id}>{f.name}</option>
        ))}
      </select>
    </div>
  );
}
